import React, { memo, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, platformMessageStore } from '@pascal/pascal-core';

import CardItem from './cardItem';
import { gameStore } from '../../../store/gameStore';
import { marketsStore } from '../../../store/marketsStore';

const CardResult = observer(() => {
  const { latestMarkets } = marketsStore;
  const { pastRoundsHighLowData, updateCompareCardResults } = gameStore;
  const { isRepliedGame } = platformMessageStore;

  useEffect(() => {
    if (latestMarkets.length && !isRepliedGame) {
      updateCompareCardResults();
    }
  }, [latestMarkets.length, isRepliedGame]);

  const cardResultItem = () =>
    latestMarkets.map(({ card, id, anim, isRotated }, index) => {
      return (
        <CardItem
          id={id}
          key={id}
          card={card}
          highOrLowData={pastRoundsHighLowData}
          isRotated={isRotated ? 'rotate-cards' : ''}
          position={`${index === 0 && !anim ? 'prev' : ''} ${anim ? 'prev next' : ''}`}
        />
      );
    });

  if (isMobile()) {
    return <div className='m-g-sm-cards-inside'>{cardResultItem()}</div>;
  }

  return <div className='m-g-sm-cards-inside'>{cardResultItem()}</div>;
});

export default memo(CardResult);
